import { createFileRoute } from '@tanstack/react-router';
import { AdditionalFormPage } from '@/pages/forms/additional/AdditionalFormPage';

export const Route = createFileRoute('/forms/additional/$token')({
	component: AdditionalFormPage,
});
